export default {
  props: {
    // Expect the component using the mixin to have a `readonly` prop
    readonly: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      isBeforeUnloadListenerActive: false // Track listener state
    };
  },
  watch: {
    readonly: {
      handler(isReadonly) {
        if (!isReadonly) {
          this.addBeforeUnloadListener();
        } else {
          this.removeBeforeUnloadListener();
        }
      },
      immediate: true // Check status immediately on mount
    }
  },
  methods: {
    addBeforeUnloadListener() {
      if (!this.isBeforeUnloadListenerActive) {
        window.addEventListener('beforeunload', this.handleBeforeUnload);
        this.isBeforeUnloadListenerActive = true;
      }
    },
    removeBeforeUnloadListener() {
      if (this.isBeforeUnloadListenerActive) {
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
        this.isBeforeUnloadListenerActive = false;
      }
    },
    handleBeforeUnload(event) {
      // Only show the warning if the component is currently in edit mode
      if (!this.readonly) { 
        const confirmationMessage = "You have unsaved changes and the document remains locked for other users. Please use Save or Cancel on the page to save your changes and release the lock.";
        event.preventDefault();
        event.returnValue = confirmationMessage; // For modern browsers
        return confirmationMessage; // For older browsers
      }
      // If readonly, do nothing (allow navigation/closure)
    }
  },
  beforeDestroy() {
    // Clean up the listener when the component is destroyed
    this.removeBeforeUnloadListener();
  }
}; 